<ng-container *ngIf="browseSections$ | async as sections">
  <section class="provider-container" *ngIf="sections.length" aria-labelledby="provider-title">
    <div class="provider-title">
      <h4 id="provider-title">
        Find a provider{{ currentStateName ? ` in ${currentStateName}` : '' }} that <em class="italic-text">meets your
          needs</em>
      </h4>
      <p>
        Finding the right therapist takes time. Browse more options to find someone who truly fits your needs.
      </p>
    </div>

    <div class="provider-content" role="main">
      <section
        *ngFor="let section of sections"
        class="search-by-type"
        [attr.aria-labelledby]="section.headingId">
        <h6 [id]="section.headingId">{{ section.title }}</h6>
        <a
          *ngFor="let item of section.items"
          class="search-link"
          [href]="item.url"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="section.ariaLabelPrefix + ' ' + item.value">
          {{ item.value }}
        </a>
      </section>
    </div>

    <div class="show-more-container" *ngIf="hasMore$ | async">
      <a (click)="toggleShowAll()" class="search-link">
        {{ (showAll$ | async) ? 'Show less' : 'Show more' }}
      </a>
    </div>
  </section>
</ng-container>
